var lib_core = require("lib-core");
var ui_templates = require("ui-templates");
var PackageGeneratorTypes = require("./packageGeneratorTypes.js");
var IpcImageHelper = require('../../../shared/extensions/footprintGenerator/ipcImageHelper.js');
var IpcImages = require("../../../shared/extensions/footprintGenerator/ipcImages/index.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");

var PackageGeneratorView = function(tabView, masterView, editorView, model, stateMachine, events, configuration) {
    var self = this;
    this.tabView = tabView;
    this.masterView = masterView;
    this.editorView = editorView;
    this.model = model;
    this.stateMachine = stateMachine;
    this.events = events; //used in inspector view
    this.configuration = configuration;
    
    this.getLocaleString = this.model.userSettingsModel.getLocaleString;
    this.LCLZ = this.getLocaleString.bind(model.userSettingsModel); //store lengthier localization fn as LCLZ

    // a little hacky but we don't want generation Available/
    // when we don't have a place to save it.
    if(tabView.rootStateMachine.root.asset && tabView.rootStateMachine.root.asset.id == -1) return;

    //add toggle button to tab
    if(this.configuration && this.configuration.button) {
    	this.toggleButton = tabView.registerButton({
            name: this.model.toggleButtonName(),
            title: this.model.toggleButtonName(),
            sortOrder: 2,
            eventType: lib_core.GuiEvents.TOGGLE_PACKAGE_SIDEBAR,
            scope: this.model.scope(),
            style: {
                icon: this.configuration.button.style.icon
            },
            group: "toggle buttons"
        });
    }

    //show or hide toggle button
    if(this.model.showToggleButton()) {
        this.toggleButton.show();
    } else {
        this.toggleButton.hide();
    }

    this.warningPopupForOverwritingPackage = null;
    this.warningPopupForCreatingFirstVersion = null;
    this.popupForHubList = null;

    this.pinNumberSequencePatternPopUp = null;
    this._template = null;

    this.packageGeneratorListItems = [];

    //add all available package types to the package generator list
    this.addPackageTypes();

    //show package search UI
    this.addPackageSearchView();

    this.initListeners();

    //show generator interaction view if it exists
    if(this.model.selectedIM()) {
        this.showPackageGeneratorInteractionView(this.model.selectedIM());
    }

    //hide finish button
    this.getTemplate().hideFinishButton();

    //hide fork button
    self.getTemplate().hideForkButton();

    //if IPC parametric data is dirty on page load enable update preview button and show sidebar if 3d model is not added manually
    if(!this.model.isParametricDataDirty()) {
        this.disablePreviewButtonAndRestoreColor();
    } else {
        if(!this.model.data.is3dModelUploadedManually()) {
            this.showSidebar();
            if(this.toggleButton) this.toggleButton.setActive();
        }

        this.enablePreviewButtonAndChangeColor();
    }
};

lib_core.mixin(PackageGeneratorView, ui_extensions.InspectorView.prototype);
module.exports = PackageGeneratorView;

PackageGeneratorView.prototype.initListeners = function() {
    var self = this;

    this.model.showGenerator.onChange(this, function(show) {
        if(show) {
            self.showSidebar();
            if(self.toggleButton) self.toggleButton.setActive();
        } else{
            self.hideSidebar();
            if(self.toggleButton) self.toggleButton.setInActive();
        }
    }, 1);

    this.model.selectedIM.onChange(this, function(im) {
        if(im) {
            self.showPackageGeneratorInteractionView(im, self.model.showIPCParametersInReadOnlyMode());
        } else {
            self.hidePackageGeneratorInteractionView();
        }
    });

    this.initWarninPopupListenerForOverwriting();
    this.initWarninPopupListenerForFinishingGeneration();
    this.initWarninPopupListenerForUnfinishedPackageUpdatePreview();
    this.initWarninPopupListenerForOpeningForkedPackage();

    //finish button
    this.model.showFinishButton.onChange(this, function(show) {
        if(show) {
            self.getTemplate().showFinishButton();
        } else {
            self.getTemplate().hideFinishButton();
        }
    });

    //hide generator when setting page is displayed
    //TODO: attach sidebar in tab view outside of editor
    this.masterView.model.activeTab.onChange(this, function() {
        //if other tab is selected
        if(self.masterView.model.activeTab() !== 'package_3d_tab') {
            //hide generator if it is visible
            if(self.model.showGenerator() || self.model.showIPCParametersInReadOnlyMode()) {
                self._sidebarTemplate.hide();
            }
        } else {
            //show generator again if package 3d tab is active
            if(self.model.showGenerator() || self.model.showIPCParametersInReadOnlyMode()) {
                self._sidebarTemplate.show();
            }
        }
    });

    this.model.isParametricDataDirty.onChange(this, function(isDirty) {
        if(isDirty) {
            self.enablePreviewButtonAndChangeColor();
        } else {
            self.disablePreviewButtonAndRestoreColor();
        }
    });

    this.model.toggleButtonName.onChange(this, function(name) {
        self.toggleButton.updateName(name);
        self.toggleButton.updateTitle(name);
    });

    this.model.showToggleButton.onChange(this, function(show) {
        if(show) {
            self.toggleButton.show();
        } else {
            self.toggleButton.hide();
        }
    });

    this.model.showIPCParametersInReadOnlyMode.onChange(this, function(show) {
        if(show) {
            self.showSidebar();

            if(!self.model.only3dModelGeneratedFromIPCParam() && !self.configuration.disableIpcForking) {
                self.getTemplate().showForkButton();
            }
        } else {
            //do not hide sidebar when showGenerator flag in model class is set (user clicks generate model button when IPC params are visible in readonly mode)
            if(!self.model.showGenerator()) self.hideSidebar();
            self.getTemplate().hideForkButton();
        }
    }, 1);

    this.model.previewPackageName.onChange(this, function(val) {
        if(val) {
            self.masterView.setTitle(val);
        }
    });

    this.model.showPackageSearchBox.onChange(this, function(show) {
        if(show) {
            self.showPackageSearchBoxWithCloseButton();
        } else {
            self.hidePackageSearchBoxWithCloseButton();
        }
    });

    //filter package generator list by search name
    this.model.packageGeneratorSearchName.onChange(this, function(val) {
        self.filterPackageGeneratorList(val);

        if(!val) {
            self.getTemplate().clearPackageSearchBox();
        }
    });

    //hide back button and show package list when back button is clicked
    this.getTemplate().$el.on('Cioui:PackageGeneratorBackButton:clicked', function(e){
        e.stopImmediatePropagation();
        self.hidePackageGeneratorInteractionView();

        var cEvent = new lib_core.GuiEvent()
                .type(lib_core.GuiEvents.GENERATOR_BACK_BUTTON_PRESSED);

        return self.stateMachine.handle(cEvent);
    });

    //listener for update preview button
    this.getTemplate().$el.on('Cioui:PackageGeneratorUpdatePreviewButton:clicked', function(e){
        e.stopImmediatePropagation();

        var cEvent = new lib_core.GuiEvent()
                .type(lib_core.GuiEvents.GENERATE_PACKAGE);

        return self.stateMachine.handle(cEvent);
    });

    //listener for finish button
    this.getTemplate().$el.on('Cioui:PackageGeneratorFinishButton:clicked', function(e){
        e.stopImmediatePropagation();

        var cEvent = new lib_core.GuiEvent()
                .type(lib_core.GuiEvents.FINISH_PACKAGE);

        return self.stateMachine.handle(cEvent);
    });

    //listener for fork button
    this.getTemplate().$el.on('Cioui:PackageGeneratorForkButton:clicked', function(e){
        e.stopImmediatePropagation();

        var cEvent = new lib_core.GuiEvent()
                .type(lib_core.GuiEvents.START_FORK_PACKAGE_FROM_IPC_PARAMS);

        return self.stateMachine.handle(cEvent);
    });

    //listener for package search button
    this.getTemplate().$el.on('Cioui:PackageGeneratorSearchButton:clicked', function(e){
        e.stopImmediatePropagation();

        var cEvent = new lib_core.GuiEvent()
                .type(lib_core.GuiEvents.PACKAGE_SEARCH_BUTTON_CLICKED);

        return self.stateMachine.handle(cEvent);
    });

    //listener for package search close button
    this.getTemplate().$el.on('Cioui:PackageGeneratorSearchCloseButton:clicked', function(e){
        e.stopImmediatePropagation();

        var cEvent = new lib_core.GuiEvent()
                .type(lib_core.GuiEvents.PACKAGE_SEARCH_CLOSE_BUTTON_CLICKED);

        return self.stateMachine.handle(cEvent);
    });

    //listener for package search box value
    this.getTemplate().$el.on('Cioui:PackageGeneratorSearchBox:value', function(e, val){
        e.stopImmediatePropagation();

        var cEvent = new lib_core.GuiEvent()
                .type(lib_core.GuiEvents.PACKAGE_SEARCH_BOX_TEXT_ENTERED)
                .data('value', val);

        return self.stateMachine.handle(cEvent);
    });

    this.model.hubsList.onChange(this, function(list) {
        self.showHubsListPopup(list);
    });
};

PackageGeneratorView.prototype.getAvailablePackageTypes = function() {
    var types = PackageGeneratorTypes.NonElectroMechanical;
    
    if (this.configuration.includeElectroMechanicalGenerators) {
        types = types.concat(PackageGeneratorTypes.ElectroMechanical);
    }
    
    if (this.configuration.includeFusionOnlyGenerators) {
        types = types.concat(PackageGeneratorTypes.FusionOnly);
    }
    
    for (var i in types) {
        types[i].name = this.LCLZ(types[i].localeKey, types[i].name)
    }
    return types;
};

PackageGeneratorView.prototype.cleanupPopup = function(popUpUIElement) {
    if(popUpUIElement) {
        popUpUIElement.remove();
        popUpUIElement = null;
    }
};

PackageGeneratorView.prototype.showHubsListPopup = function(list) {
    //TODO: what if no hubs present - show popup?
    if(list.length == 0) return;

    var self = this;
    var selectedHub = list[0].value;

    self.cleanupPopup(self.popupForHubList);

    self.popupForHubList = new ui_templates.Modal({
        target: $("body"),
        fields: {
            'title': 'Select Managed Folder',
            'closeOnClick': true,
            'modal': true,
            'body': 'Select a Managed Folder to copy this package into.'
        }
    });

    self.popupForHubList.setTheme(self.configuration.theme);

    var hubSelectBox = self.popupForHubList.addSelectBox("Available Folders:", list);

    hubSelectBox.$el.on('Cioui:Modal:selectbox:value', function(e, val) {
        selectedHub = val;
        return;
    });

    //Start Button
    var forkButton = self.popupForHubList.addButton("Start");
    forkButton.$el.on('Cioui:Modal:ModalButton:clicked', function() {
        self.cleanupPopup(self.popupForHubList);
        var forkEvent = null;

        if(self.model.forkMode === self.model.FORK_MODE_CONSTANT.MODE_1) {
            forkEvent = new lib_core.GuiEvent(lib_core.GuiEvents.HUB_SELECTED_AND_START_FORK_PACKAGE_FROM_IPC_PARAMS);
        } else if(self.model.forkMode === self.model.FORK_MODE_CONSTANT.MODE_2) {
            forkEvent = new lib_core.GuiEvent(lib_core.GuiEvents.HUB_SELECTED_AND_START_FORK_PUBLIC_PACKAGE);
        }

        return self.stateMachine.handle(forkEvent.data("selectedTargetHub", selectedHub));
    });

    //CANCEL Button
    var cancelButton = self.popupForHubList.addButton("Cancel", (self.configuration.theme == "light")?"inverted":self.configuration.theme);
    cancelButton.$el.on('Cioui:Modal:ModalButton:clicked', function() {
        self.cleanupPopup(self.popupForHubList);
        return;
    });

    self.popupForHubList.$el.on('Cioui:Modal:close:clicked', function() {
        self.cleanupPopup(self.popupForHubList);
        return;
    });
};

PackageGeneratorView.prototype.initWarninPopupListenerForOverwriting = function() {
    var self = this;

    this.model.showPackageOverwritingWarningPopup.onChange(this, function(show) {
        self.cleanupPopup(self.warningPopupForOverwritingPackage);

        if(show) {
            self.warningPopupForOverwritingPackage = new ui_templates.Modal({
                target: $("body"),
                fields: {
                    'title': "Clear Package?",
                    'closeOnClick': true,
                    'modal': true,
                    'body': 'Do you want to overwrite existing package?'
                }
            });

            self.warningPopupForOverwritingPackage.setTheme(self.configuration.theme);

            var yesButton = self.warningPopupForOverwritingPackage.addButton("Yes");
            yesButton.$el.on('Cioui:Modal:ModalButton:clicked', function() {
                return self.stateMachine.handle(lib_core.GuiEvents.OVERWRITE_PACKAGE);
            });

            var noButton = self.warningPopupForOverwritingPackage.addButton("No", (self.configuration.theme == "dark")? "inverted": "");
            noButton.$el.on('Cioui:Modal:ModalButton:clicked', function() {
                return self.stateMachine.handle(lib_core.GuiEvents.HIDE_WARNING_POPUP_PACKAGE_OVERWRITING);
            });

            self.warningPopupForOverwritingPackage.$el.on('Cioui:Modal:close:clicked', function() {
                return self.stateMachine.handle(lib_core.GuiEvents.HIDE_WARNING_POPUP_PACKAGE_OVERWRITING);
            });
        }
    });
};

PackageGeneratorView.prototype.initWarninPopupListenerForFinishingGeneration = function() {
    var self = this;

    this.model.showWarningPopupForFinishingGeneration.onChange(this, function(show) {
        self.cleanupPopup(self.warningPopupForFinishingGeneration);

        if(show) {
            var modalTitle = "";
            var bodyMsg = "";
            var yesBtnEvent = null;

            if(self.model.masterModel && self.model.masterModel.wizardMode()) {
                modalTitle = "Finish Package Generator";
                bodyMsg = "A version of your package will be created, after which you can generate new packages starting from this package's parameters.";

                yesBtnEvent = new lib_core.GuiEvent(lib_core.GuiEvents.FINISH_PACKAGE_VERSION_CREATION);
            } else if(self.model.masterModel && !self.model.masterModel.wizardMode()) {
                modalTitle = "Finish Model Generator";
                bodyMsg = "A version of your package will be created using the generated 3D model. All footprint geometry will be preserved.";

                yesBtnEvent = new lib_core.GuiEvent(lib_core.GuiEvents.FINISH_PACKAGE_VERSION_CREATION);
            }

            self.warningPopupForFinishingGeneration = new ui_templates.Modal({
                target: $("body"),
                fields: {
                    'title': modalTitle,
                    'closeOnClick': true,
                    'modal': true,
                    'body': bodyMsg
                }
            });

            self.warningPopupForFinishingGeneration.setTheme(self.configuration.theme);

            if(self.model.masterModel && !self.model.masterModel.wizardMode()) {
                //add checkbox for settings override in nonwizard mode
                var overrideSettingsCheckBox = self.warningPopupForFinishingGeneration.addCheckBox("Rename package and overwrite summary, description and metadata based on IPC parameters.", self.model.overridePackageSettings());

                overrideSettingsCheckBox.$el.on('Cioui:Modal:checkbox:clicked', function(e, isChecked) {
                    var checkBoxEvent = new lib_core.GuiEvent(lib_core.GuiEvents.OVERRIDE_PACKAGE_SETTINGS)
                                        .data('isChecked', isChecked);
                    return self.stateMachine.handle(checkBoxEvent);
                });
            }

            //YES Button
            var yesButton = self.warningPopupForFinishingGeneration.addButton("OK");
            yesButton.$el.on('Cioui:Modal:ModalButton:clicked', function() {
                self.cleanupPopup(self.warningPopupForFinishingGeneration);
                return self.stateMachine.handle(yesBtnEvent);
            });

            //CANCEL Button
            var cancelButton = self.warningPopupForFinishingGeneration.addButton("Cancel", (self.configuration.theme == "dark")?"dark": 'inverted');
            cancelButton.$el.on('Cioui:Modal:ModalButton:clicked', function() {
                return self.stateMachine.handle(lib_core.GuiEvents.HIDE_WARNING_POPUP_FINISH_GENERATION);
            });

            self.warningPopupForFinishingGeneration.$el.on('Cioui:Modal:close:clicked', function() {
                return self.stateMachine.handle(lib_core.GuiEvents.HIDE_WARNING_POPUP_FINISH_GENERATION);
            });
        }
    });
};

PackageGeneratorView.prototype.initWarninPopupListenerForUnfinishedPackageUpdatePreview = function() {
    var self = this;

    this.model.showWarningPopupForUnfinishedPackageUpdatePreview.onChange(this, function(show) {
        self.cleanupPopup(self.warningPopupForUnfinishedPackageUpdatePreview);

        if(show) {
            self.warningPopupForUnfinishedPackageUpdatePreview = new ui_templates.Modal({
                target: $("body"),
                fields: {
                    'title': self.LCLZ("updatePreview", "Update Preview"),
                    'closeOnClick': true,
                    'modal': true,
                    'body': 'Please click update preview to apply your changes before finishing this package.'
                }
            });


            self.warningPopupForUnfinishedPackageUpdatePreview.setTheme(self.configuration.theme);

            var okButton = self.warningPopupForUnfinishedPackageUpdatePreview.addButton("OK");
            okButton.$el.on('Cioui:Modal:ModalButton:clicked', function() {
                var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.HIDE_WARNING_POPUP_UNFINISHED_UPDATE_PREVIEW);
                return self.stateMachine.handle(cEvent);
            });

            self.warningPopupForUnfinishedPackageUpdatePreview.$el.on('Cioui:Modal:close:clicked', function() {
                return self.stateMachine.handle(lib_core.GuiEvents.HIDE_WARNING_POPUP_UNFINISHED_UPDATE_PREVIEW);
            });
        }
    });
};

PackageGeneratorView.prototype.initWarninPopupListenerForOpeningForkedPackage = function() {
    var self = this;

    this.model.showWarningPopupForOpeningForkedPackage.onChange(this, function(show) {
        self.cleanupPopup(self.warningPopupForOpeningForkedPackage);

        if(show) {
            self.warningPopupForOpeningForkedPackage = new ui_templates.Modal({
                target: $("body"),
                fields: {
                    'title': "Package Forked",
                    'modal': true,
                    'body': 'A new package has been created from this package. To edit the package <a href="'
                            + self.model.forkedPackageURL + '" target="_blank">click here</a>' + '.'
                }
            });

            self.warningPopupForOpeningForkedPackage.setTheme(self.configuration.theme);

            self.warningPopupForOpeningForkedPackage.$el.on('Cioui:Modal:close:clicked', function() {
                return self.stateMachine.handle(lib_core.GuiEvents.HIDE_WARNING_POPUP_OPEN_FORKED_PACKAGE);
            });
        }
    });
};

PackageGeneratorView.prototype.getTemplate = function() {
    if(!this._template) {
        //add sidebar to master view
        this._sidebarTemplate = this.masterView.getTemplate().addSidebar(this.configuration.sidebar.position, this.configuration.sidebar.width, this.configuration.sidebar.theme);
        this._sidebarTemplate.hide();

        this._template = this._sidebarTemplate.addPackageGenerator(this.model.generatorSidebarTitle(), this.configuration.sidebar.width, this.configuration.sidebar.theme);
    }

    return this._template;
};

PackageGeneratorView.prototype.addPackageTypes = function() {
    var self = this;
    var packageTypes = this.getAvailablePackageTypes();

    this._packageGeneratorListTemplate = self.getTemplate().addList();

    //sort types by name
    packageTypes.sort(function(t1, t2) {
        if(t1.name < t2.name) {
            return -1;
        } else if(t1.name > t2.name) {
            return 1;
        }

        return 0;
    });

    //add all package types in sidebar
    packageTypes.forEach(function(packageTypeItem) {
        var itemThumbnail = packageTypeItem.thumbnail ? global.FULLDEPLOYMENTPATH + packageTypeItem.thumbnail : "https://123d-circuits-assets.s3.amazonaws.com/thumbnotfound.png";
        var item = self._packageGeneratorListTemplate.addItem(packageTypeItem.name, itemThumbnail);

        item.$el.on('Cioui:SidebarPackageGeneratorListItem:clicked', function(e){
            e.stopImmediatePropagation();

            var cEvent = new lib_core.GuiEvent()
                    .type(lib_core.GuiEvents.GENERATOR_SELECTED)
                    .data('packageTypeItem', packageTypeItem);

            return self.stateMachine.handle(cEvent);
        });

        self.packageGeneratorListItems[packageTypeItem.name] = item;
    });
};

PackageGeneratorView.prototype.addPackageSearchView = function() {
    this.getTemplate().showPackageSearch();
    this.hidePackageSearchBoxWithCloseButton();
};

PackageGeneratorView.prototype.showPackageSearchBoxWithCloseButton = function() {
    this.getTemplate().showPackageSearchBox();
    this.getTemplate().showPackageSearchCloseButton();
    this.getTemplate().hidePackageSearchButton();
};

PackageGeneratorView.prototype.hidePackageSearchBoxWithCloseButton = function() {
    this.getTemplate().hidePackageSearchBox();
    this.getTemplate().hidePackageSearchCloseButton();
    this.getTemplate().showPackageSearchButton();
};

PackageGeneratorView.prototype.showSidebar = function() {
    this._sidebarTemplate.show();
};

PackageGeneratorView.prototype.hideSidebar = function() {
    this._sidebarTemplate.hide();
};

//reusing inspector view to add ui elements for input fields in sidebar
PackageGeneratorView.prototype.showInputForm = function(imageUrl, formUIElements, readOnlyMode) {
    if(this._packageGeneratorFormTemplate) {
        this._packageGeneratorFormTemplate.remove();
    }

    if(this._packageGeneratorRefImageTemplate) {
        this._packageGeneratorRefImageTemplate.remove();
    }

    this._packageGeneratorRefImageTemplate = this.getTemplate().addRefImage(imageUrl); //add IPC ref image
    this._packageGeneratorFormTemplate = this.getTemplate().addForm(); //add IPC input form

    this.build(formUIElements.input_elements, undefined, this._packageGeneratorFormTemplate, readOnlyMode);
};

PackageGeneratorView.prototype.showPackageGeneratorInteractionView = function(im, readOnlyMode) {
    if(!im) return;

    var imageUrl = IpcImageHelper.getDimensionImage(im.parametricData);
    var formUIElements = im.getInspectorElements();

    this._packageGeneratorListTemplate.hide();

    if(!readOnlyMode) {
        this.getTemplate().showBackButton();
    } else {
        this.getTemplate().hideBackButton();
    }

    if(!readOnlyMode) {
        formUIElements.help_elements.name = this.LCLZ(formUIElements.help_elements.name, formUIElements.help_elements.name) + " " + this.LCLZ("Generator", "Generator");
    }

    this.getTemplate().setTitle(formUIElements.help_elements.name);
    this.getTemplate().setUpdatePreviewButtonTitle(this.LCLZ("updatePreview", "Update Preview"));
    this.showInputForm(imageUrl, formUIElements, readOnlyMode);

    if(!readOnlyMode) {
        this.getTemplate().showUpdatePreviewButton();
    } else {
        this.getTemplate().hideUpdatePreviewButton();
    }

    this.getTemplate().hidePackageSearch();
};

PackageGeneratorView.prototype.hidePackageGeneratorInteractionView = function() {
    this.getTemplate().hideBackButton();
    this.getTemplate().setTitle(this.model.generatorSidebarTitle());
    this.getTemplate().hideUpdatePreviewButton();
    this._packageGeneratorRefImageTemplate.remove();
    this._packageGeneratorFormTemplate.remove();

    this._packageGeneratorListTemplate.show();
    this.addPackageSearchView();
};

PackageGeneratorView.prototype.enablePreviewButtonAndChangeColor = function() {
    this.getTemplate().enableUpdatePreviewButton();
    this.getTemplate().changeUpdatePreviewButtonColor();
};

PackageGeneratorView.prototype.disablePreviewButtonAndRestoreColor = function() {
    this.getTemplate().disableUpdatePreviewButton();
    this.getTemplate().restoreUpdatePreviewButtonColor();
};

PackageGeneratorView.prototype.filterPackageGeneratorList = function(searchString) {
    var self = this;
    var packageTypes = this.getAvailablePackageTypes();

    packageTypes.forEach(function(packageTypeItem) {
        self.packageGeneratorListItems[packageTypeItem.name].show();
    });

    if(searchString) {
        //hide the packages with name which does not match with search string
        var packageTypesHidden = packageTypes.filter(function(packageTypeItem) {
            return packageTypeItem.name.toLowerCase().indexOf(searchString.toLowerCase()) < 0;
        });

        packageTypesHidden.forEach(function(packageTypeItem) {
            self.packageGeneratorListItems[packageTypeItem.name].hide();
        });
    }
};
